/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.inputs', []);

})();



// WEBPACK FOOTER //
// ./node_modules/blur_admin/src/app/theme/inputs/inputs.module.js